// @ts-nocheck
import React from "react";
import { FC } from "react";
import { IProduct } from "../../types";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import { darken } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import { usePayment } from "../../hooks/usePayment";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import FontIcon from "../../../../components/FontIcon";

interface CartMenuContentProps {
  cart: IProduct[];
}

const useStyles = makeStyles((theme: Theme) => ({
  item: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  itemTitle: {
    paddingRight: theme.spacing(1),
  },
  total: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
  deleteContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
  deleteButton: {
    paddingRight: 0,
    color: theme.palette.error.main,
    "&:hover": {
      background: "none",
      color: darken(theme.palette.error.main, 0.1),
    },
  },
}));

const CartMenuContent: FC<CartMenuContentProps> = ({ cart, ...props }) => {
  const classes = useStyles();

  const {
    actions: { removeFromCart },
  } = usePayment();
  return (
    <>
      {cart.map((cartItem, index) => (
        <div key={`CartItem_${cartItem.id}`}>
          {index > 0 && <Divider />}
          <Grid className={classes.item} container alignItems={"center"}>
            <Grid item xs={8} className={classes.itemTitle}>
              <Typography variant={"body2"}>{cartItem.name}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant={"body2"} align={"right"}>
                ${cartItem.price}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.deleteContainer}>
              <IconButton
                disableRipple
                className={classes.deleteButton}
                onClick={() => removeFromCart(cartItem.id)}
              >
                <FontIcon fontSize={"small"} color={"error"} name={"delete"} />
              </IconButton>
            </Grid>
          </Grid>
          {index === cart.length - 1 && <Divider />}
        </div>
      ))}
      <Typography align={"right"} className={classes.total}>
        <strong>
          Total: ${cart.reduce((total, item) => total + item.price, 0)}
        </strong>
      </Typography>
    </>
  );
};

export default React.memo(CartMenuContent);
